import { render, staticRenderFns } from "./Seguimiento.vue?vue&type=template&id=85319dc8"
import script from "./Seguimiento.vue?vue&type=script&lang=js"
export * from "./Seguimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports